import { useState, useContext, useRef, useEffect } from "react";
import Dashboardmain from "../dashboardmain";
import { MyContext } from "../../../MyContext/MyProvider";
import { useNavigate } from "react-router-dom";
import { getEmail, isLoggedIn, notify } from "../../../utils/utils";
import { uploadFilesAPI } from "../../../APIs/API";
import { v4 as uuidv4 } from "uuid";

const Fileupload = () => {
  const {
    docs,
    setDocs,
    selectedDocs,
    setSelectedDocs,
    setProcessedFiles,
    setIsLoading,
  } = useContext(MyContext);

  const navigate = useNavigate();

  const onUploadClick = () => {
  };
 
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);
  const [statesSet, setStatesSet] = useState(false);
  useEffect(() => {
    console.log(isLoggedIn())
    
    if(!isLoggedIn() ){
      console.log("hello")
      notify("Session expired", "error");
      window.location.href = "/login"

    }
  }, []);
  useEffect(() => {
    if (statesSet) {
      setIsLoading(true);
      const executeTryBlock = async () => {
        try {
          const email = getEmail();
          const res = await uploadFilesAPI({ files: selectedDocs, email });
          console.log("response:", res);
          setProcessedFiles(res);
          navigate("/finding");
        } catch (error) {
          console.log(error);
        } finally {
          console.log("first");
          setIsLoading(false);
        }
      };

      executeTryBlock();
      setStatesSet(false);
    }
  }, [statesSet, selectedDocs]);



  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const uploadedFiles = Array.from(e.dataTransfer.files).map((file) => ({
        id: uuidv4(),
        name: file.name,
        file: file,
      }));
      setDocs(uploadedFiles);
      setSelectedDocs(uploadedFiles);
      setStatesSet(true);
    }
  };

  const handleChange = async (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      const uploadedFiles = Array.from(e.target.files).map((file) => ({
        id: uuidv4(),
        name: file.name,
        file: file,
      }));
     
      setDocs(uploadedFiles);
      setSelectedDocs(uploadedFiles);
      setStatesSet(true);
    }
  };

  const onButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <>
      <Dashboardmain hide="d-none" />
      <div className="doc-main-container">
       
        {docs.length === 0 && (
          <div className="no-doc-div v-center flex-column">
            {/* <h4 className="roboto-family">No Documents Uploaded!</h4>{" "} */}
            {/* <button
              className="btn-primary fw-bold inter-family"
              onClick={onUploadClick}
            >
              Get Started
            </button> */}
          </div>
        )}
      </div>
      <div className="fileupload-main-container h-center v-center flex-column w-100">
        <div className="import-csv-content v-center flex-column">
          <form
            id="form-file-upload"
            className="v-center flex-column"
            onDragEnter={handleDrag}
            onSubmit={(e) => e.preventDefault()}
          >
            <img
              src="../../assets/images/dashboardimages/file.svg"
              alt=""
              onClick={onButtonClick}
            />
            <input
              ref={inputRef}
              type="file"
              id="input-file-upload"
              multiple={true}
              onChange={handleChange}
              accept=".pdf,.txt,.doc,.docx,.jpg,.png"
            />
            <label
              id="label-file-upload"
              htmlFor="input-file-upload"
              className={dragActive || docs.length ? "drag-active" : ""}
            >
              <h1 className="text-medium-black fw-medium">
                Drop files to upload or{" "}
                <button type="button" onClick={onButtonClick}>
                  <h1 className="text-blue text-underline fw-medium">browse</h1>
                </button>
              </h1>
            </label>
            {dragActive && (
              <div
                id="drag-file-element"
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
              ></div>
            )}
          </form>
        </div>
        <label className="small mt-2 fw-normal text-light-gray">
          Supported files: .pdf, .txt, .doc, .docx, .jpg, .png
        </label>
      </div>
     
    </>
  );
};

export default Fileupload;
